const Config = {
  StackName: "prod-doc-analyzer",
  DefaultImageName: "default_document_3.png",
  CognitoIdentityPoolId: "us-east-1:dc024f99-0146-47a0-af1d-1fa9000867a2",
  CognitoUserPoolId: "us-east-1_cyv83Tj1c",
  DeployRegion: "us-east-1",
  CognitoId: "cognito-idp.us-east-1.amazonaws.com/us-east-1_cyv83Tj1c",
  APIUrl: "/prod",
  LogoutUrl:
    "https://prod-vanguard-platform.auth.us-east-1.amazoncognito.com/logout?client_id=3rvfomscs7fqcbu2fj1l4q44ms&logout_uri=https://portal.vg.spsglobal.com&redirect_uri=https://portal.vg.spsglobal.com&response_type=token",
  LoginUrl:
    "https://prod-vanguard-platform.auth.us-east-1.amazoncognito.com/login?client_id=3rvfomscs7fqcbu2fj1l4q44ms&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://portal.vg.spsglobal.com",
  ChatExternalLink: "https://www.google.com",
  TicketExternalLink: null,
  AnalyticsExternalLink: "https://reports.vg.spsglobal.com/",
  OperatorHubExternalLink: "/operator-hub/",
  TicketTableColumns: {
    ticket: { visible: true },
    title: { visible: true },
    subject: { visible: true },
    status: { visible: true },
    docClass: { visible: true },
    lob: { visible: true },
    created: { visible: true },
    checkNumber: { visible: false, hideIfEmpty: true },
    checkType: { visible: false, hideIfEmpty: true },
    checkAmount: { visible: false, hideIfEmpty: true },
    comments: { visible: true },
    view: { visible: true },
    action: { visible: true },
  },
};

export default Config;
